import { createStore, combineReducers, applyMiddleware } from 'redux'
import reducer from './reducer'
import thunk from 'redux-thunk'

const rootReducer = combineReducers({
    reducer: reducer
})

const logger = () => {
    return next => {
        return action => {
            return next(action)
        }
    }
}

const store = createStore(rootReducer, applyMiddleware(logger, thunk))

export default store